export const convertToWeeksAndDays = (totalDays: number) => {
    const isNegative = totalDays < 0;
    const absDays = Math.abs(totalDays);
    const weeks = Math.floor(absDays / 7);
    const days = absDays % 7;
    const parsedWeeks = isNegative ? -weeks - (days > 0 ? 1 : 0) : weeks;
    const parsedDays = isNegative ? (7 - days) % 7 : days;
    return `${parsedWeeks} Weeks and ${parsedDays} Days`;
};
